module.exports = __webpack_public_path__ + "static/media/WatchlistShoes1.0f5526e3.png";